import { axiosAccountInstance } from "api/Request";

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";

import toast from "../../../../../components/Toastify";
import Tables from "views/examples/Tables";
import { setCompanyBookingExtentionInfo } from "redux/actions/admin/BookingExtentionRequestAction";
import { fetchUserData } from "helpers/storageData";
import BookingExtentionModal from "components/Modals/BookingExtentionModal";
import approveIcn from "../../../../../assets/img/icons/customIcons/approve.svg";
import rejectIcn from "../../../../../assets/img/icons/customIcons/reject.svg";
import viewIcn from "../../../../../assets/img/icons/customIcons/view.svg";
import SOWUploadModal from "components/Modals/SOWUploadModal";
import { updatePendingCount } from "redux/actions/admin/PendingCountRequestAction";

function CompanyBookingextentionPendingCard({ loader }) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [data, setData] = useState([]);
  const [bookingId, setBookingId] = useState("");
  const [errors, setErrors] = useState(null);
  const [rejectRequestReason, setRejectRequestReason] = useState("");
  const [bookingData, setBookingData] = useState({});
  const [bookingModal, setBookingModal] = useState(false);
  // const [btnStatus, setBtnStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const socketInstance = useSelector((state) => state.socketReducer.result);
  const pendingCompnayRequestList = useSelector(
    (state) => state.BookingExtentionApprovalRequestReducer.result
  );
  const [sowHistory, setSOWHistory] = useState([]);

  const [approveFormData, setApproveFormData] = useState({
    _id: null,
    sow_status: null,
    sowDocument: null,
  });

  const [isApproveButtonDisabled, setIsApproveButtonDisabled] = useState(true); //multiple click disabled
  const [sowModal, setSOWModal] = useState(false);
  const [sowData, setSOWData] = useState([]);
  const close = () => {
    setRejectRequestReason("");
    setSOWModal(false);
    setModal(false);
    setBookingModal(false);
    setErrors({ ...errors, sowDocument: null });
  };

  const imageSelect = (image) => {
    if (image) {
      setIsRejectButtonDisabled(false);
    }

    const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB maximum size limit
    if (image.size > MAX_IMAGE_SIZE) {
      setErrors({
        ...errors,
        sowDocument: `File size exceeds the maximum limit of ${
          MAX_IMAGE_SIZE / (1024 * 1024)
        }MB`,
      });
      setApproveFormData({
        ...approveFormData,
        sowDocument: null,
      });
      setIsApproveButtonDisabled(true);
    } else {
      setErrors({ ...errors, sowDocument: null });
      setApproveFormData({
        ...approveFormData,
        sowDocument: image,
      });
      setIsApproveButtonDisabled(false);
    }
    // setErrors({ ...errors, sowDocument: null });
    // setApproveFormData({
    //   ...approveFormData,
    //   sowDocument: image,
    // });
    // setIsApproveButtonDisabled(false);
  };

  const onApproveSOW = async () => {
    setIsApproveButtonDisabled(true);
    const finalData = approveFormData;
    if (!finalData?.sowDocument) {
      setErrors({ ...errors, sowDocument: "SOW document required" });
    } else {
      const data = new FormData();
      data.append("_id", finalData?._id);
      data.append("sowDocument", finalData?.sowDocument);
      data.append("sow_status", finalData?.sow_status);
      submitRequestSOW(data, "approved");
    }
  };
  useEffect(() => {
    setData(pendingCompnayRequestList?.booking || []);
  }, [pendingCompnayRequestList]);

  const handleOnChange = (e) => {
    if (e.target.value) {
      setIsRejectButtonDisabled(false);
    }
    setRejectRequestReason(e.target.value);
    setErrors({ ...errors, rejectRequestReason: null });
  };

  const rejectHandler = (bookingId) => {
    setBookingId(bookingId);
    setModal(!modal);
  };

  const validation = (data) => {
    const errorsFound = {};

    if (!rejectRequestReason || rejectRequestReason === "") {
      errorsFound["rejectRequestReason"] = "Reject Request Reason is required";
    }

    if (Object.keys(errorsFound).length !== 0) {
      setErrors(errorsFound);
      return false;
    }
    return true;
  };
  const totalPendingCount = useSelector(
    (state) => state.PendingCountRequestReducer.result
  );
  // TODO - approve and reject a booking extention
  const setBookingExtentionApproval = (isValid = true, data) => {
    if (isValid) {
      // setBtnStatus(true);
      setLoading(true);
      let subType = "";
      axiosAccountInstance
        .post("/booking/extention_status_update", data)
        .then((res) => {
          if (res.data.statusCode === 200) {
            if (data.extentionStatus === "approved") {
              subType = "UPDATE_APPROVED_BOOKING_EXTENTION_LIST";
              toast.success(res.data.body.message);
            } else {
              subType = "UPDATE_REJECTED_BOOKING_EXTENTION_LIST";
              toast.success(res.data.body.message);
            }
            // setBtnStatus(false);
            setLoading(false);
            socketInstance.emit("message", {
              type: "UPDATE_BOOKING_EXTENTION",
              subType: subType,
              key: data?.bookingId,
              extraInfo: fetchUserData().companyName,
            });
            setSOWModal(false);

            dispatch(setCompanyBookingExtentionInfo("0", "1", "pending", null));
            const currentCount=totalPendingCount?.inbound_bookings?.length > 0 ? (totalPendingCount?.inbound_bookings[2]?.pending_extension_request)-1 : 0
            dispatch(updatePendingCount("INBOUND_PENDING_EXTENSION_LIST_COUNT_UPDATE",currentCount));
            setModal(false);
          }
        })
        .catch((err) => {
          // setBtnStatus(false);
          setLoading(false);
          toast.error(err.response.data.body.message);
        });
      setRejectRequestReason("");
    }
  };

  const setBookingExtentionApprovalSOW = (isValid = true, data) => {
    if (isValid) {
      // setBtnStatus(true);
      setLoading(true);
      let subType = "";
      axiosAccountInstance
        .post("/booking/sow_request/approve", data)
        .then((res) => {
          if (res.data.statusCode === 200) {
            if (data.extentionStatus === "approved") {
              subType = "UPDATE_APPROVED_BOOKING_EXTENTION_LIST";
              toast.success(res.data.body.message);
            } else {
              subType = "UPDATE_REJECTED_BOOKING_EXTENTION_LIST";
              toast.success(res.data.body.message);
            }
            // setBtnStatus(false);
            setLoading(false);
            socketInstance.emit("message", {
              type: "UPDATE_BOOKING_EXTENTION",
              subType: subType,
              key: data?.bookingId,
              extraInfo: fetchUserData().companyName,
            });
            setSOWModal(false);
            dispatch(setCompanyBookingExtentionInfo("0", "1", "pending", null));

            // dispatch(setSowInfo("0", "1", "pending", null));
            setModal(false);
          }
        })
        .catch((err) => {
          // setBtnStatus(false);
          setLoading(false);
          toast.error(err.response.data.body.message);
        });
      setRejectRequestReason("");
    }
  };

  const submitRequest = (data) => {
    if (data.status === "rejected") {
      const isValid = validation(data);
      setBookingExtentionApproval(isValid, data);
    } else {
      setBookingExtentionApproval(true, data);
    }
  };

  const submitRequestSOW = (data) => {
    if (data.status === "rejected") {
      const isValid = validation(data);
      setBookingExtentionApprovalSOW(isValid, data);
    } else {
      setBookingExtentionApprovalSOW(true, data);
    }
  };

  const [isRejectButtonDisabled, setIsRejectButtonDisabled] = useState(false); //multiple click disabled
  const onReject = () => {
    setIsRejectButtonDisabled(true);
    const finalData = {
      bookingId: bookingId,
      extentionStatus: "rejected",
      extentionRejectReason: rejectRequestReason,
    };

    submitRequest(finalData);
  };

  const onApprove = (bookingId) => {
    const finalData = {
      bookingId,
      extentionStatus: "approved",
    };
    submitRequest(finalData);

    setModal(false);
  };
  const viewHandler = (dataObj) => {
    setBookingData(dataObj);
    setBookingModal(true);
  };
  const sowRequestHandler = (id, data) => {
    setIsApproveButtonDisabled(false);
    console.log("sow data  ", data);
    setSOWModal(!sowModal);
    setSOWData(data);

    setSOWHistory(data?.activity?.filter((obj) => obj.action.includes("SOW")));
  };
  const colums = [
    { columnName: "Employee Name", columnTag: "name", type: "data" },

    // { columnName: "Company", columnTag: "bookedCompany", type: "data" },
    { columnName: "Employee ID", columnTag: "empId", type: "data" },
    { columnName: "Designation", columnTag: "designation", type: "data" },
    { columnName: "Date Range", columnTag: "duration", type: "objectData" },
    {
      columnName: "Hourly Rate",
      columnTag: "hourlyPayment",
      type: "paymentMapping",
    },

    {
      columnName: "SOW",
      columnTag: "sow_final_status",
      type: "data",
      actionSOWApprove: sowRequestHandler,
    },

    { columnName: "Status", columnTag: "extentionStatus", type: "data" },
    { columnName: "", columnTag: "", type: " " },
  ];
  const actionButtons = [
    {
      columnName: "",
      btnTitle: "View",
      type: "actionButton",
      btn: "ViewBooking",
      btnType: "primary",
      btnIcon: viewIcn,
      actionFunction: viewHandler,
      btnTooltip: "View",
    },
    {
      columnName: "",
      type: "actionButton",
      btnTitle: "Approve",
      btnType: "primary",
      btnIcon: approveIcn,
      btn: "BookingExtentionApproval",
      actionFunction: onApprove,
      btnTooltip: "Approve",
      // btnStatus: btnStatus,
      loading: loading,
    },
    {
      columnName: "",
      btnTitle: "Reject",
      type: "actionButton",
      btnIcon: rejectIcn,
      btn: "BookingExtentionReject",
      btnType: "danger",
      btnTooltip: "Reject",
      actionFunction: rejectHandler,
    },
  ];
  return (
    <div>
      {data && (
        <Tables
          coloums={colums}
          data={pendingCompnayRequestList?.booking}
          actionButtons={actionButtons}
          loader={loader}
        />
      )}

      <Modal toggle={close} centered isOpen={modal}>
        <Row>
          <div className="col">
            <ModalHeader className="text-uppercase font-weight-bolder">
              Reject Booking
            </ModalHeader>
          </div>
          <Row>
            <Col>
              <ModalHeader className="text-uppercase">
                <Button onClick={close} className="mx-1" close />
              </ModalHeader>
            </Col>
          </Row>
        </Row>
        <ModalBody>
          <label className="font-weight-normal">
            Do you want to reject the booking request?
          </label>
          <FormGroup row>
            <Label for="exampleText" sm={12}>
              Rejection Remarks
            </Label>
            <Col sm={12}>
              <Input
                id="exampleText"
                name="text"
                type="textarea"
                onChange={handleOnChange}
                value={rejectRequestReason}
                invalid={!!errors && !!errors.rejectRequestReason}
              />
              <FormFeedback
                className={errors?.rejectRequestReason && "invalid-field"}
              >
                {errors?.rejectRequestReason}
              </FormFeedback>
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            onClick={() => onReject()}
            color="primary"
            disabled={isRejectButtonDisabled}
          >
            Submit
          </Button>{" "}
          {/* <Button size="sm" onClick={close}>
              Cancel
            </Button> */}
        </ModalFooter>
      </Modal>
      <SOWUploadModal
        sowModal={sowModal}
        close={close}
        onApproveSOW={onApproveSOW}
        sowHistory={sowHistory}
        isApproveButtonDisabled={isApproveButtonDisabled}
        errors={errors}
        imageSelect={imageSelect}
        sowData={sowData}
      />

      <BookingExtentionModal
        modal={bookingModal}
        close={close}
        data={bookingData}
      />
    </div>
  );
}

export default CompanyBookingextentionPendingCard;
